export default {
  permissions: {},
  roles: {},
}
